import React from 'react';
import { HomeAudiences } from '../components/home/HomeAudiences';
import { HomeConsultants } from '../components/home/HomeConsultants';
import { HomeHero } from '../components/home/HomeHero';
import { HomeIndustries } from '../components/home/HomeIndustries';
import { HomeInsights } from '../components/home/HomeInsights';
import { HomeIntro } from '../components/home/HomeIntro';
import { HomeProcess } from '../components/home/HomeProcess';
import { HomeServices } from '../components/home/HomeServices';
import { HomeWhy } from '../components/home/HomeWhy';
import { ButtonLink } from '../components/ui/ButtonLink';
import { CtaBand } from '../components/ui/CtaBand';
import { consultants } from '../data/consultants';
import { services } from '../data/services';
import { usePageMeta } from '../hooks/usePageMeta';
import { SITE_NAME } from '../utils/seo';
export function Home() {
  usePageMeta(SITE_NAME, 'Aurevane Search Partners is an executive search firm connecting organizations with exceptional leaders for C-suite, board, and senior leadership appointments, including confidential searches.', {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: SITE_NAME,
    description: 'Executive search, C-suite recruitment, board and non-executive director search, and leadership talent advisory.',
    url: typeof window !== 'undefined' ? window.location.origin : undefined,
    serviceType: services.map(s => s.title),
    employee: consultants.map(c => ({
      '@type': 'Person',
      name: c.name,
      jobTitle: c.title
    }))
  });
  return <>
      <HomeHero data-id="element-824" data-mp="2895kd4v9kmr3" />
      <HomeIntro data-id="element-825" data-mp="288nfjjujd07k" />
      <HomeServices data-id="element-826" data-mp="2861dfzqezcwq" />
      <HomeIndustries data-id="element-827" data-mp="239awla6scda9" />
      <HomeProcess data-id="element-828" data-mp="239sqi05z6ff0" />
      <HomeWhy data-id="element-829" data-mp="23ac5p948qppc" />
      <HomeConsultants data-id="element-830" data-mp="23auboxgpgiag" />
      <HomeAudiences data-id="element-831" data-mp="1z7fwg90lc5y2" />
      <HomeInsights data-id="element-832" data-mp="1z7xnmr8ebtz4" />
      <CtaBand title="The Right Leadership Can Change Everything." text="Whether you are building your leadership team or considering your next executive opportunity, begin a conversation with Aurevane Search Partners." data-id="element-833" data-mp="1z6ebnctrw535">
        <ButtonLink to="/contact" size="lg" data-id="element-834" data-mp="1kn3cyesjdt23">
          Contact Our Team
        </ButtonLink>
        <ButtonLink to="/consultants" variant="outline-light" size="lg" data-id="element-835" data-mp="1ok7wkjz33vox">
          Meet Our Consultants
        </ButtonLink>
      </CtaBand>
    </>;
}